export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-12.a913bec4.png";